module.exports = __webpack_public_path__ + "img/logo-premium.5d05b943.svg";